import type { NextWorkflowError } from 'models/NextWorkflowError';
import { connect } from 'react-redux';
import { getFormQuoteRejections, getIsUserInternal, getQuoteSolvingMode, getStaticFormInfos } from 'state/selectors';
import type { AppState } from 'state/state.model';
import type { QuoteWorkspaceType } from 'state/workspaces/model';

export interface QuoteRejectedOwnProps {
  tabId: string;
  workspaceType: QuoteWorkspaceType;
}

export interface QuoteRejectedStateProps {
  productSubtype?: string;
  errors?: readonly NextWorkflowError[];

  shouldDisplayErrorDetails: boolean;
  shouldDisplayStandardErrorMessage?: boolean;
  shouldUseRejectionCode?: boolean;
  solvingMode?: string;
}

export const mapStateToProps = (
  state: AppState,
  { tabId, workspaceType }: QuoteRejectedOwnProps,
): QuoteRejectedStateProps => {
  const isInternal = getIsUserInternal(state);
  const errors = getFormQuoteRejections(state, workspaceType, tabId);
  const productSubtype = workspaceType === 'static' ? getStaticFormInfos(state, tabId)?.productDescription : undefined;
  const solvingMode = getQuoteSolvingMode(state, tabId);

  return {
    errors,
    productSubtype,
    shouldDisplayErrorDetails: isInternal,
    shouldDisplayStandardErrorMessage: !isInternal,
    shouldUseRejectionCode: !isInternal,
    solvingMode,
  };
};

export const connectRejected = connect(mapStateToProps);
